﻿'use strict';

angular.module('ntmApp').factory('RoomInstructions', ['FlashService', 'DailyPlanService', function (FlashService, DailyPlanService) {

    function RoomInstructions(context) {

        var self = this;

        self.load = function () {

            var request = context.getViewModeSelectedDateAndRoomInfo();

            self.roomInfoChanging = true;
            DailyPlanService.GetRoomInformation(request).then(function (result) {
                self.instructions = result.data;
                self.instructionsCopy = angular.copy(self.instructions);
                self.roomInfoChanging = false;
            });

        };

        self.cancelRoomInformation = function (form, nextAction) {
            self.instructions = angular.copy(self.instructionsCopy);
            form.$setPristine();
            if (nextAction) {
                nextAction();
            }
        };

        self.saveRoomInformation = function (form, nextAction) {

            var request = context.getViewModeSelectedDateAndRoomInfo();
            request.roomInstructions = self.instructions.roomInstructions;
            DailyPlanService.SaveRoomInformation(request).then(function (result) {
                self.instructionsCopy = angular.copy(self.instructions);
                FlashService.Success(result.data.message);
                if (nextAction) {
                    nextAction();
                }
            });

            form.$setPristine();
        };

        self.tinymceOptions = {
            selector: 'textarea',
            height: 300,
            menubar: false,
            plugins: [
              'advlist autolink lists link image charmap print preview anchor',
              'searchreplace visualblocks code fullscreen',
              'insertdatetime media table contextmenu paste code'
            ],
            toolbar: 'undo redo | insert | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image',
            content_css: [
              '//fonts.googleapis.com/css?family=Lato:300,300i,400,400i',
              '//www.tinymce.com/css/codepen.min.css']
        };
    }

    return (RoomInstructions);

}]);